module.exports = __webpack_public_path__ + "img/group-2@3x.70160445.png";